class Auth {
    authenticated = false;

    login(data) {
        const token = data.token;

        sessionStorage.setItem('_pelago', token);

        if (token) {
            this.authenticated = true;
        } else {
            this.authenticated = false;
        }
    }

    // logout() {
    //     localStorage.removeItem('_pelago')
    //     this.authenticated = false;
    // }

    user() {
        let user = sessionStorage.getItem('_pelagoUser');

        return JSON.parse(user);
    }

    // logout() {
    //     localStorage.removeItem('_pelago');
    //     localStorage.removeItem('_pelagoUser');
    //     this.authenticated = false;
    // }

    getToken() {
        return sessionStorage.getItem('_pelago')
    }

    getCompanyID() {
        return sessionStorage.getItem("_companyID")
    }

    setCompanyID(ID) {
        sessionStorage.setItem("_companyID", ID)
    }
    setCompanyWorkingDays(workingDays) {
        sessionStorage.setItem("workingDays", workingDays)
    }

    getCompanyHexaID() {
        return sessionStorage.getItem("_companyHexaID")
    }

    setCompanyHexaID(ID) {
        sessionStorage.setItem("_companyHexaID", ID)
    }

    isUserAuthenticated() {
        if (sessionStorage.getItem('_pelago')) {
            return true
        } else {
            return false
        }
    }
  
}

export default new Auth();